import { CanActivateFn, Router } from '@angular/router';
import { StoreService } from '../services/store.service';
import { inject } from '@angular/core';
import { SecurityService } from '../services/security.service';

export const isAuthorizedGuard: CanActivateFn = (route, state) => {
  const storeService = inject(StoreService);
  const router = inject(Router);
  const securityService = inject(SecurityService);
  let isAuthorized: boolean = true;
  let isLogged = localStorage.getItem('isLogged');

  if (state.url === '/login' && isLogged === 'true') {
    router.navigateByUrl('/home');
  } else {
    switch (state.url) {
      case '/producers-wastes':
        isAuthorized = securityService.canDisplayProducersWastes();
        break;
      case '/suppliers':
        isAuthorized = securityService.canDisplaySuppliers();
        break;
      case '/price-list':
        isAuthorized = securityService.canDisplayPriceList();
        break;
      case '/demand-prestations':
        isAuthorized = securityService.canDisplayDemandPrestations();
        break;
      case '/prestations-completed':
        isAuthorized = securityService.canDisplayPrestationsCompleted();
        break;
      case '/integrate-services':
        isAuthorized = securityService.canDisplayIntegratePrestationEffectuees();
        break;
      case '/purchase-orders':
        isAuthorized = securityService.canDisplayPurchaseOrders();
        break;
      case '/billing-preparation':
        isAuthorized = securityService.canDisplayBillingPreparation();
        break;
      case '/customer-control':
        isAuthorized = securityService.canDisplayCustomerControl();
        break;
      case '/technical-reports':
        isAuthorized = securityService.canDisplayTechnicalReports();
        break;
      case '/reporting':
        isAuthorized = securityService.canDisplayReporting();
        break;
      case '/contracts':
        isAuthorized = securityService.canDisplayContracts();
        break;
      case '/users':
        isAuthorized = securityService.canDisplayUsers();
        break;
      case '/tgap':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/configuration':
        isAuthorized = securityService.canDisplayConfiguration();
        break;
      case '/referentials/natures':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/conditionnements':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/prestations':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/immobilisation-demande':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/annulation-demande':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/adr':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/ced':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/units':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      case '/referentials/outil-achat':
        isAuthorized = securityService.canDisplayReferentials();
        break;
      default:
        isAuthorized = true;
    }
    if (!isAuthorized) {
      router.navigateByUrl('/home');
    }
  }

  return isAuthorized;
};
